/** This file contains the route of entire project */
import Icons from 'components/typed-icons';

import { Menu, MODULE_NAME } from 'model/constants';
import type { IRouterProps } from 'model/interfaces';

import { kf1GetModuleRegistry, kf1ImportRemoteComponent } from 'kfone-frontend-core';
import type { ComponentType, FC, LazyExoticComponent } from 'react';
import { JSX, lazy, Suspense, useEffect, useId, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ILazyRouteProps, IModuleRegistry } from '../model/interfaces/module';
import { useRouteStore } from '../store';
import PeerGroupsPage from 'pages/peer-groups/peer-groups';
import SearchFilters from 'components/JobPricing/SearchFilters';
import { PAGE_URL } from 'constants/urls.constants';
import FunctionsList from 'pages/JobPricing/Functions';
import SearchResults from 'pages/JobPricing/SearchResults';
import ClientSelection from 'pages/PayAnalytics/ClientSelection';
import Landing from 'pages/PayAnalytics/Landing';
import MyQueries from 'pages/PayAnalytics/MyQueries';
import RewardBenchMark from 'pages/PayAnalytics/RewardBenchMark';
import ReportsPage from 'pages/PayEquity/ReportsPage';
import { ReportDetails } from 'pages/JobPricing/ReportDetails/ReportDetails';
import withSessionManager from 'components/modal/session-modal';

// const PeerGroupsPage: LazyExoticComponent<FC> = lazy(
//   () => import('../pages/peer-groups/peer-groups'),
// );

const GlobalRouter = () => {
  const [routeProps, setRouteProps] = useState<ILazyRouteProps[]>([]);
  const { dispatch }: any = useRouteStore();
  const menuID: string = useId();
  const { setMenuItems } = Menu;

  useEffect(() => {
    const data: ILazyRouteProps[] = generateRouteProps(
      kf1GetModuleRegistry(),
      <div>Error Ocurred</div>,
      <div>Loading...</div>,
    );

    const payload: IRouterProps[] = data?.map((item: any, index: number) => {
      return {
        id: menuID + index,
        label: item?.label,
        route: item?.path,
        icon: item?.label === 'Remote Page' ? Icons.Remote : Icons.Module,
      };
    });
    dispatch({
      type: setMenuItems,
      payload: payload,
    });
    setRouteProps(data);
  }, []);

  const generateRouteProps = (
    moduleRegistry: IModuleRegistry,
    errorComponent: JSX.Element,
    fallbackComponent: JSX.Element,
  ): ILazyRouteProps[] => {
    // //to validate env variables method
    // const data = kf1GetEnvironmentVariables(moduleRegistry?.modules[1]?.name);
    // console.log('Environment Variables:', data);

    const routeProps: ILazyRouteProps[] = [];

    const filteredModules = { ...moduleRegistry }?.modules.filter(
      (module): boolean => module.name !== MODULE_NAME,
    );

    filteredModules?.forEach((module) => {
      module.exposes
        .filter((component) => !!component.route)
        .map((entry) => {
          // static import - build time
          // const Component: LazyExoticComponent<ComponentType<any>> = lazy(
          //   () => import('remote_app/RemotePage') as any,
          // );

          // dynamic import - runtime
          const Component: LazyExoticComponent<ComponentType<any>> = lazy(
            (): Promise<{ default: ComponentType<any> }> =>
              kf1ImportRemoteComponent(module.name, entry.name),
          );

          routeProps.push({
            key: entry.name,
            label: entry.displayName,
            element: <Component />,
            fallbackComponent,
            errorComponent,
            path: entry.route ?? '',
            onError: (): void => console.error(`Error trying to load ${entry.route}`),
          });
        });
    });

    return routeProps;
  };

  return (
    // <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        {/* <Route path='/' element={<NewReport />} /> */}
        {/* <Route path='/' element={<PeerGroupsPage />} /> */}
        {/* <Route path='/' element={<Navigate to='/pay-analytics' />} /> */}
        <Route path='/' element={<Landing />}></Route>
        <Route path='/pay-analytics' element={<Landing />}></Route>
        <Route path='/payanalytics' element={<Landing />}></Route>
        <Route path='/payanalytics/home' element={<Landing />}></Route>
       

         <Route path="/pay-analytics/Home" element={<Landing/>} />
                  <Route path="/pay-analytics/my-reports" element={<MyQueries/>} />
                  <Route
                    
                    path="/pay-analytics/client-selection"
                    element={<ClientSelection/>}
                  />
                  <Route
                    
                    path="/sjpr"
                    element={<SearchFilters/>}
                  />
                  <Route
                    
                    path={PAGE_URL.JOB_PRICING_DETAILS}
                    element={<ReportDetails/>}
                  />
                  <Route
                    
                    path="/pay-equity/reports/:clientId"
                    element={<ReportsPage/>}
                  />
                  {/* <Route
                    
                    path="/pay-analytics/reward-benchmark"
                    element={<Landing/>}
                  /> */}
                  <Route
                    
                    path="/pay-analytics/reward-benchmark"
                    element={<RewardBenchMark/>}
                  />
                  <Route  path="/jobs" element={<FunctionsList/>} />
                  <Route
                    
                    path="/sjpr/job-search-results"
                    element={<SearchResults/>}
                  />
                   {/* <Route path='*' element={<Navigate to='/' />} /> */}

        {routeProps.map((rp: any) => (
          <Route key={rp.key} path={rp.path} element={rp.element} />
        ))}
      </Routes>
    // </Suspense>
  );
};

export default withSessionManager(GlobalRouter);
